<template>
    <iframe class="frame-body" :src="url">

    </iframe>
</template>

<style>
    .frame-body{
        border: 0px;
        width: 100%;
        height: calc(100% - 4px)
    }
</style>

<script>
    import { RouterMeta } from "../../route"
    export default {
        data:function(){
            return {
                url:""
            }
        },
        created:function(){
            this.url = this.$store.state.baseUrl + "/api/customPage/" + this.$route.params.customPageId;
            this.$watch(
                () => this.$route.params,
                (toParams, previousParams) => {
                    if(this.$route.meta.name == RouterMeta.customPage.name){
                        this.url =this.$store.state.baseUrl + "/api/customPage/" + toParams.customPageId;
                    }
                }
            )
        }
    }
</script>